var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toolbar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8417 8.18545L13.1779 9.84923M12.249 5.59272L9.7533 8.0884M17.4344 10.7782L14.9388 13.2738M22.6199 15.9636L20.1242 18.4593M20.0271 13.3709L18.3634 15.0347M24.2403 17.5841C24.777 18.1208 24.7867 18.9823 24.2617 19.5072L19.5083 24.2606C18.9834 24.7855 18.1219 24.7759 17.5852 24.2392L3.86537 10.5194C3.63616 10.2902 3.50398 9.98269 3.49791 9.6646C3.49184 9.34651 3.61239 9.04386 3.83302 8.82323L8.7054 3.95085C9.23032 3.42593 10.0918 3.43558 10.6285 3.97227L24.2403 17.5841Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.32923ed6685444007c108a535a59cd17.svg";
export { ForwardRef as ReactComponent };